import React from 'react';
import { Box, Container, Typography } from '@mui/material';

/**
 * 認證頁面通用布局組件
 * 白色背景，靜態紅色龍鳳圖騰置於兩側
 */
interface AuthPageLayoutProps {
  children: React.ReactNode;
  pageTitle?: string;
  pageSubtitle?: string;
}

export const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({
  children,
  pageTitle,
  pageSubtitle,
}) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        py: 4,
        backgroundColor: '#ffffff',
      }}
    >
      {/* 龍圖騰（左側，靜態） */}
      <Box
        component="img"
        src="/dragon2.png"
        alt="龍"
        sx={{
          position: 'fixed',
          left: { xs: '4px', sm: '4%', md: '8%', lg: '13%' },
          top: '50%',
          transform: 'translateY(-50%)',
          width: { xs: '110px', sm: '170px', md: '220px', lg: '270px' },
          height: 'auto',
          opacity: 0.9,
          pointerEvents: 'none',
        }}
      />

      {/* 鳳凰圖騰（右側，靜態） */}
      <Box
        component="img"
        src="/fenghuang2.png"
        alt="鳳凰"
        sx={{
          position: 'fixed',
          right: { xs: '4px', sm: '4%', md: '8%', lg: '13%' },
          top: '50%',
          transform: 'translateY(-50%)',
          width: { xs: '110px', sm: '170px', md: '220px', lg: '270px' },
          height: 'auto',
          opacity: 0.9,
          pointerEvents: 'none',
        }}
      />

      {/* 內容容器 */}
      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1 }}>
        {/* 主標題 */}
        <Box textAlign="center" mb={4}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 900,
              color: '#C62828',
              mb: 0.5,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
              letterSpacing: '0.05em',
            }}
          >
            我的好運氣！
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: '#555',
              letterSpacing: '0.15em',
              fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem' },
            }}
          >
            HowYun.Me
          </Typography>
        </Box>

        {/* 副標題（頁面標題 / 說明） */}
        {pageTitle && (
          <Box textAlign="center" mb={3}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: '#333',
                mb: 0.5,
              }}
            >
              {pageTitle}
            </Typography>
            {pageSubtitle && (
              <Typography
                variant="body1"
                sx={{ color: '#666' }}
              >
                {pageSubtitle}
              </Typography>
            )}
          </Box>
        )}

        {/* 子組件內容 */}
        {children}
      </Container>
    </Box>
  );
};
